module.exports = __webpack_public_path__ + "static/media/049-tunisia.d28b4e8f.svg";